import { AppError } from "./AppError.js";
import { CombinedError } from "../graphql/index.js";
class NotFoundError extends AppError {
    constructor(entityType, slug){
        super({
            title: `We can't find that ${entityType}`,
            message: `The ${entityType}${void 0 === slug ? '' : ` ${slug}`} might not exist anymore,
        or there's a typo in the URL. Contact the owner for more information.
      `
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
function isNotFoundError(error) {
    return error instanceof NotFoundError || error instanceof CombinedError && error.message.match(/\[GraphQL\] Resource.*not found/);
}
export { NotFoundError, isNotFoundError };

//# sourceMappingURL=NotFoundError.js.map